import { FeatureManagementType } from "@api/apiClient";
import useAppStore from "@hooks/useAppStore";

export const useAdditionalMetadataFeature = () => {
  const appStore = useAppStore();

  return {
    isEnabled: appStore.hasFeature(FeatureManagementType.AdditionalMetadata)
  };
};
